import GeocodingV6 from '@mapbox/mapbox-sdk/services/geocoding-v6'
import mapboxgl from 'mapbox-gl'

import { ArtisanPartFromMapbox } from './Artisan'

export type { Coordinates } from '@mapbox/mapbox-sdk/lib/classes/mapi-request'
export { Map as MapboxMap } from 'mapbox-gl'

mapboxgl.accessToken =
  'pk.eyJ1Ijoiem96by1uZXh0IiwiYSI6ImNsdXFwdnhtcDAwcmMyanNhaWhueHk3a2YifQ.Q94zOKD12c7_hYkk6OhVJA'
export const mapboxglClient = mapboxgl

export const getGeocoding = async (
  query: string,
): Promise<ArtisanPartFromMapbox> => {
  const isSpecialWard = (place: string) => /東京都.{1,3}区/.test(place)

  const response = await GeocodingV6({ accessToken: mapboxgl.accessToken })
    .forwardGeocode({
      query,
      autocomplete: false,
      language: 'en',
      worldview: 'jp',
      // 23区は市町村名がTokyoと表示されてしまうため、localityを指定する
      types: [isSpecialWard(query) ? 'locality' : 'place'],
      limit: 1,
    })
    .send()

  const feature = response.body.features[0]
  // 東京都のみTokyo Prefectureとなるため余計な部分を削除
  const prefectureEn = feature.properties.context.region?.name.split(' ')[0]
  // 23区の場合末尾につく-kuを削除
  const cityEn = feature.properties.name_preferred?.replace(/-ku$/, '')
  if (!prefectureEn || !cityEn) {
    throw new Error(
      `No prefecture or city found in geocoding features for ${query}`,
    )
  }

  return {
    coordinates: feature.geometry.coordinates,
    prefectureEn,
    cityEn,
  }
}
